import React from 'react';

/**
 * Componente de alerta de error reutilizable
 *
 * @param {Object} props - Propiedades del componente
 * @param {string} props.message - Mensaje de error a mostrar
 * @returns {JSX.Element|null}
 */
function ErrorAlert({ message }) {
  if (!message) return null;

  return (
    <div className="alert alert-danger">
      <i className="fas fa-exclamation-triangle"></i>
      <span>{message}</span>
    </div>
  );
}

export default ErrorAlert;
